define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/defineProperties',
    '../Util/bind',
    '../Util/encode',
    '../Util/callbackSystem',
    '../System/ColorObj'
], function (
    defaultValue,
    defined,
    defineProperties,
    bind,
    encode,
    callbackSystem,
    ColorObj
) {
    'use strict'

    class Atmosphere {
        /**
         * @description 大气层显隐状态。
         * @type {Boolean}
         * @default true
         */
        bVisible
        /**
         * @description 大气层对象uuid。
         * @type {String}
         * @readonly
         */
        avatarUuid = null
        /**
         * @description 大气层组件uuid。
         * @type {String}
         * @readonly
         */
        componentUuid = null
        /**
         * @description Atmosphere在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "Atmosphere"
        static avatarType = "deSMP.Avatar.EnvironmentAvatar"
        static componentType = "AvatarComponent.Environment.AtmosphereComponent"

        /**
         * 大气层。
         * <br /><br />
         * <div align='center'>
         * <img src='images/Atmosphere.gif' width='900' height='650' /><br />
         * 大气层效果图
         * </div>
         * 
         * @demo {@link http://lbs.zjkelan.com/Atmosphere.html|CooWasm Atmosphere demo}
         * @alias Atmosphere
         * @constructor
         *
         * @param {Object} props 包含如下属性的Object：
         * @param {Boolean} [props.bVisible = true] 大气层显隐状态。
         * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
         * @example
         * var atmosphere = new CooWasm.Atmosphere({},(state)=>{console.log("load status:" + state)})
         */
        constructor(props, callback) {
            if (!defined(props)) {
                return
            }
            if(defined(props.build) && props.build == true){
                return
            }
            this.bVisible = defaultValue(props.bVisible, true)
            //create avatars
            var aCategory = encode("deSMP.Avatar")
            var aName = encode("EnvironmentAvatar")
            var cCategory = encode("AvatarComponent.Environment")
            var cName = encode("AtmosphereComponent")
            var aProps = ""
            var cProps = ""
            var idInfo = Element.prototype.NativeAPI.LoadAvatarAndComponent(encode(""), aCategory, aName, encode(aProps), cCategory, cName, encode(cProps), encode(""), encode(""), this.bVisible, true)
            if (idInfo != "") {
                var idArray = idInfo.split('#$%')
                this.avatarUuid = idArray[0]
                this.componentUuid = idArray[1]
                callbackSystem.register("LoadAvatarAndComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                    Element.prototype.Map.atmospheres.push(this)
                })
                //console.log("Atmosphere avatarUuid:" + this.avatarUuid + " componentUuid:" + this.componentUuid)
            }
        }

        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {Boolean} [props.bVisible] 大气层显隐状态。
         * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
         * @example
         * atmosphere.update({
         *    bVisible:false
         * },(state)=>{console.log("update status:" + state)})
         */
        update(props, callback) {
            let avatarProps = ""
            let componentProps = ""
            if (defined(props)) {
                if (defined(props.bVisible)) {
                    this.bVisible = props.bVisible
                    avatarProps += "Visible:" + this.bVisible + "|"
                }
                callbackSystem.register("UpdateAvatarAndComponent", this.avatarUuid, (state) => {
                    if (defined(callback)) {
                        callback(state)
                    }
                })
                Element.prototype.NativeAPI.UpdateAvatarAndComponent(encode(this.avatarUuid), encode(this.componentUuid), encode(avatarProps), encode(componentProps), defined(callback))
            }
        }

        /**
         * 获取大气层包含的属性。
         * @returns {Boolean} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * ato.getProperties()
         */
        getProperties() {
            if (!defined(this.avatarUuid)) {
                console.log("uuid require!")
                return false
            }
            let pAvatarUuid = Element.prototype.NativeAPI.Uuid_New()
            Element.prototype.NativeAPI.Uuid_SetId(pAvatarUuid, encode(this.avatarUuid))
            let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid)
            let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar)
            for (let i = 0; i < avatarPropSize; ++i) {
                let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i)
                let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                if (name == "Visible") {
                    if (value == "true" || value == "1") {
                        this.bVisible = true
                    } else {
                        this.bVisible = false
                    }
                }
            }
            Element.prototype.NativeAPI.Avatar_Delete(pAvatar)
            Element.prototype.NativeAPI.Uuid_Delete(pAvatarUuid)
            return true
        }

        /**
         * 从场景中销毁自身。
         * @param {CallbackBoolean} [callback=null] 销毁后触发的函数回调。
         * @returns null 空值。
         * @example
         * atmosphere = atmosphere.destroy((state)=>{console.log("destroy status:" + state)})
         */
        destroy(callback) {
            if(!defined(this.avatarUuid)){
                console.log("avatarUuid is null!")
                return null
            }
            callbackSystem.register("RemoveAvatar", this.avatarUuid, (state) => {
                if (defined(callback)) {
                    callback(state)
                }
                Element.prototype.Map.atmospheres = Element.prototype.Map.atmospheres.filter(item => item !== this)
                callbackSystem.remove("LoadAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("UpdateAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("RemoveAvatar", this.avatarUuid)
                this.avatarUuid = null
                this.componentUuid = null
            })
            Element.prototype.NativeAPI.RemoveAvatar(encode(this.avatarUuid))
            return null
        }
    }
    return Atmosphere
})